"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.cellDataGetter = exports.CurrentAlarmCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseReducers = require("nicbase-reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cellDataGetter = function cellDataGetter(_ref) {
  var rowData = _ref.rowData;
  var lastBoxDataStatus = rowData.lastBoxDataStatus,
      owningPortal = rowData.owningPortal;
  return {
    lastBoxDataStatus: lastBoxDataStatus,
    owningPortal: owningPortal
  };
};

exports.cellDataGetter = cellDataGetter;

var CurrentAlarmCell = function CurrentAlarmCell(_ref2) {
  var cellData = _ref2.cellData;
  var activePortal = (0, _nicbaseReducers.usePortal)();
  var _cellData$lastBoxData = cellData.lastBoxDataStatus,
      lastBoxDataStatus = _cellData$lastBoxData === void 0 ? [] : _cellData$lastBoxData,
      owningPortal = cellData.owningPortal; // filter for alarms

  var filteredStatuses = lastBoxDataStatus.filter(function (status) {
    return 'alarmNames' in status;
  });

  if (owningPortal && activePortal.id === owningPortal.id && filteredStatuses.length > 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-wrap"
    }, filteredStatuses.map(function (status) {
      return /*#__PURE__*/_react["default"].createElement(_mapping.Status, {
        key: status.type,
        status: status,
        className: "m-1 h-6 w-6"
      });
    }));
  }

  return null;
};

exports.CurrentAlarmCell = CurrentAlarmCell;
CurrentAlarmCell.propTypes = {
  cellData: _propTypes["default"].shape({
    lastBoxDataStatus: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      type: _propTypes["default"].string,
      alarmNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
    })),
    owningPortal: _propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired
    }).isRequired
  })
};
CurrentAlarmCell.defaultProps = {
  cellData: []
};
var _default = CurrentAlarmCell;
exports["default"] = _default;